import styled from 'styled-components';
import { colors } from 'bench-style-constants';
export const ClientRulesLayout = styled.div`
  display: grid;
  grid-template-rows: 1fr min-content;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
`;

export const FormFields = styled.div`
  overflow: auto;
`;

export const FormActions = styled.div`
  display: grid;
  grid-template-columns: 120px 1fr;
  column-gap: 16px;
  padding: 8px 24px;
  background-color: ${colors.pearl};
`;

export const InlineInputLayout = styled.div`
  display: grid;
  align-items: center;
  grid-column-gap: 35px;
`;

export const ContractorInput = styled.input`
  width: 100%;
  height: 30px;
  background: #f7f8fa;
  color: ${props => props.color || 'initial'};
  font-size: 14px;
  background: #ffffff;
  border: 1px solid ${props => props.color || '#b8b7b5'};
  border-radius: 1px;

  &:focus {
    border-color: ${props => props.color || '#b8b7b5'};
  }
`;

export const EditContractorWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const EditContractorErrorWrapper = styled.div`
  margin-top: 5px;
  height: 15px;
`;

export const EditContractorError = styled.div`
  color: #d6382c;
  font-size: 14px;
  font-style: italic;
`;
